import { render, staticRenderFns } from "./BarStackWithDetails.vue?vue&type=template&id=67bf712e&scoped=true&"
import script from "./BarStackWithDetails.vue?vue&type=script&lang=js&"
export * from "./BarStackWithDetails.vue?vue&type=script&lang=js&"
import style0 from "./BarStackWithDetails.vue?vue&type=style&index=0&id=67bf712e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf712e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/matt/dev/georgia/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bf712e')) {
      api.createRecord('67bf712e', component.options)
    } else {
      api.reload('67bf712e', component.options)
    }
    module.hot.accept("./BarStackWithDetails.vue?vue&type=template&id=67bf712e&scoped=true&", function () {
      api.rerender('67bf712e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BarStackWithDetails.vue"
export default component.exports